import React from 'react';

export const SquarePointIcon: React.FC = ({width}: any) => (
    <svg
        width={width}
        height={width}
        viewBox={`-2 -2 22 22`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="18" height="18" fill="currentColor" />
    </svg>
);

export default SquarePointIcon;
